export interface IPrintPreviewMappingRatio {
    closingRatioValue: number | null;
    openingRatioValue: number | null;
}
